// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PrivacyFooter_Wrapper__pDjwg"};